import { CommonModule } from '@angular/common';
import { Component, EventEmitter, inject, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { Router, RouterModule } from '@angular/router';

import { TranslocoModule } from '@jsverse/transloco';

@Component({
  selector: 'hmax-button-arrow-back',
  standalone: true,
  imports: [CommonModule, TranslocoModule, RouterModule, MatButtonModule, MatIconModule],
  templateUrl: './button-arrow-back.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./button-arrow-back.component.scss'],
})
export class ButtonArrowBackComponent {
  private readonly _router = inject(Router);

  @Input() routerLink!: string;
  @Input() label = 'back';
  @Input() labelTranslate = true;
  @Input() tabindex!: number;
  @Input() showLabel = true;
  @Input() emitEvent = false;

  @Output() clickButton = new EventEmitter<boolean>();

  doClick(): void {
    if (this.emitEvent) {
      this.clickButton.emit(true);
    } else if (this.routerLink) {
      this._router.navigate([this.routerLink]);
    }
  }
}
